<template>
  <div class="calculator conversions">
    <br />
    <conversion-row
      id="distance"
      desc="distance"
      :from="from"
      :fromUnits="distance.fromUnits"
      :toUnits="distance.toUnits"
      :unitOptions="distance.unitOptions"
    />
    <br />
    <conversion-row
      id="weight"
      desc="weight"
      :from="from"
      :fromUnits="weight.fromUnits"
      :toUnits="weight.toUnits"
      :unitOptions="weight.unitOptions"
    />
  </div>
</template>

<script type="ts">
import ConversionRow from "@/components/conversions/ConversionRow.vue"
import { DISTANCE_UNITS, WEIGHT_UNITS } from "@/utils/constants.js"

export default {
  name: "Conversion",
  components: {
    ConversionRow,
  },
  data() {
    return {
      from: 10,
      distance: {
        fromUnits: "Meter",
        toUnits: "Centimeter",
        unitOptions: DISTANCE_UNITS,
      },
      weight: {
        fromUnits: "Kilogram",
        toUnits: "Gram",
        unitOptions: WEIGHT_UNITS,
      },
    }
  },
  computed: {
    distanceResult() {
      const result =
        Math.round(
          (this.distanceFrom *
            DISTANCE_UNITS[this.distanceFromUnits].conv *
            10000) /
            DISTANCE_UNITS[this.distanceToUnits].conv
        ) / 10000
      return String(result) + " " + DISTANCE_UNITS[this.distanceToUnits].abbr
    },
    distanceUnitOptions() {
      var options = []
      for (const [opt, obj] of Object.entries(DISTANCE_UNITS)) {
        options.push({ value: opt, label: obj.abbr })
      }
      return options
    },
    weightResult() {
      const result =
        Math.round(
          (this.distanceFrom *
            DISTANCE_UNITS[this.distanceFromUnits].conv *
            10000) /
            DISTANCE_UNITS[this.distanceToUnits].conv
        ) / 10000
      return String(result) + " " + DISTANCE_UNITS[this.distanceToUnits].abbr
    },
    weightUnitOptions() {
      var options = []
      for (const [opt, obj] of Object.entries(WEIGHT_UNITS)) {
        options.push({ value: opt, label: obj.abbr })
      }
      return options
    },
  },
}
</script>

<style>
</style>